import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core'
import { useEffect } from 'react'
import { useTranslate } from 'react-admin'

const UrgenceSelectInput = ({
  source,
  label,
  required,
  type,
  record,
  setPayload,
  payload,
  setErrors,
  errors,
  ...props
}) => {
  const translate = useTranslate()
  const options = [
    { id: 'Petite intervention', name: 'Petite intervention' },
    { id: 'Urgent', name: 'Urgent' },
  ]
  useEffect(() => {
    setPayload(() => {
      return { ...payload, [source]: record[source] }
    })
  }, [])

  const handleChange = (event) => {
    if (required && !event) {
      setErrors(() => {
        return errors.map((err) => {
          return err.id == props.id
            ? {
                id: props.id,
                source: source,
                type: type,
                label: label,
              }
            : err
        })
      })
    } else {
      setErrors(() => {
        return errors.filter((item) => item.id !== props.id)
      })
    }
    setPayload(() => {
      return { ...payload, [source]: event.target.value }
    })
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="selectUrgent">
        {translate(label, { _: label })}
      </InputLabel>
      <Select
        required={required}
        error={required && errors.find((item) => item.id == props.id)}
        labelId="selectUrgent"
        id="selectUrgent-input"
        value={payload[source]}
        onChange={handleChange}
      >
        {options.map((option) => {
          return <MenuItem value={option.id}>{option.name}</MenuItem>
        })}
      </Select>
    </FormControl>
  )
}
export default UrgenceSelectInput
